import { connect } from "react-redux";
import DatePicker from 'react-datepicker';
import moment from "moment";

var DateSpans = require("lib/data/DateSpans");

var CurrentUser = require("lib/account/CurrentUser");
var Modal = require("components/utility/AltModal");
var Spinner = require("components/utility/Spinner");
var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");
var LoadingButton = require("components/utility/LoadingButton");
var StudentDisplay = require("components/users/students/StudentDisplay");
var RosterRouting = require("lib/routing/RosterRouting");
var RosterSelectors = require('lib/selectors/RosterSelectors');

var OrgTypes = require("lib/academic/OrgTypes");
var OrgDropdown = require("components/org/OrgDropdown");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var Features = require("lib/account/Features");
require("writing/tasks/assign_task_modal.scss");

@connect(
  (state, props) => ({
    tasks: WritingSelectors.teacherPicksTasks({ state: state })
  }),
  (dispatch, props) => ({
    createTaskAssignment: (userIDs, state) => {
      // Delete all tasks first

      return dispatch(WritingActions.deleteManyTasks({
        filters: {
          subject_type: props.taskSubjectType,
          subject_id: props.taskSubjectID + ""
        },
      })).then(() => {
        var tasks = _.map(userIDs, (studentID) => {
          return {
            user_id: studentID,
            assigner_id: CurrentUser.get().id,
            subject_type: props.taskSubjectType,
            subject_id: props.taskSubjectID
          };
        });

        var query = {
          task_items: {
            quiz: state.quiz,
            practice_questions: state.practice_questions_quantity,
            review: state.review,
            due_date_enabled: state.due_date_enabled,
            due_date: new Date(state.due_date),
            exercises: state.exercise_quantity,
            question_builders: state.question_builder_quantity,
          }
        }

        if (tasks.length) {
          return dispatch(WritingActions.createTasks({ tasks, query }));
        } else {
          return Promise.resolve();
        }
      });
    }
  })
)

class AssignTaskItemsModal extends React.Component {
  constructor(props) {
    super(props);
    autobind(this);

    var defaultDate = new Date();
    defaultDate.setDate(defaultDate.getDate() + 7);

    var defaultState = _.extend(BASE_STATE, {
      loading: false,
      due_date: defaultDate.toLocaleString(),
      due_date_enabled: false,
      task_items: []
    })
    
    this.state = defaultState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.submitTasks = this.submitTasks.bind(this);
  }

  submitTasks (e) {
    $wr.nope(e)
    this.setState({ loading: true });
    this.props.createTaskAssignment(this.props.selectedUserIDs, { ...this.state }).then(() => {
      this.setState({ loading: false });
      var text = "The pick has been assigned"
      var title = "Pick Assigned";
      window.wrNotifications.triggerDropDownNotification({
        title: title, text: text, icon: "ok-sign"
      });
      this.props.onAssign();
    })
  }
  
  handleInputChange = event => {
    var target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    var name = target.name;

    this.setState({ [name]: value, none: false })

    if (name === PRACTICE_QUESTIONS && !value) {
      this.setState({ practice_questions_quantity: 0 })
    }
    if (name === PRACTICE_QUESTIONS && value) {
      this.setState({ practice_questions_quantity: 1 })
    }
    if (name === EXERCISES && !value) {
      this.setState({ exercise_quantity: 0 })
    }
    if (name === EXERCISES && value) {
      this.setState({ exercise_quantity: 1 })
    }
    if (name === QUESTION_BUILDERS && !value) {
      this.setState({ question_builder_quantity: 0 })
    }
    if (name === QUESTION_BUILDERS && value) {
      this.setState({ question_builder_quantity: 1 })
    }
  }

  handleNoneInput = event => {
    if (this.state.none) {
      this.setState(BASE_STATE)
    } else {
      var baseStateCopy = { ...BASE_STATE }
      baseStateCopy.none = true
      this.setState(baseStateCopy)
    }
  }

  renderDatePicker = () => {
    var date_picker = ''
    if (this.state.due_date_enabled) {
      date_picker = (
        <span>
          <label>
            <DatePicker data-lpignore="true" readOnly={true} selected={moment(this.state.due_date)}
              onChange={(date) => this.setState({ due_date: date.format(DateSpans.FORMAT) })} />
          </label>
          <br />
        </span>
      )
    }
    return date_picker
  }
  // renders input box to assign number of activities
  renderQuantity = (quantity_var, boolean_var) => {
    var return_val = ''
    if (this.state[boolean_var]) {
      return_val = (
        <label>
          <input
            data-lpignore="true"
            name={quantity_var}
            type="number"
            value={this.state[quantity_var]}
            onChange={this.handleInputChange} />
        </label>
      )
    }
    return return_val
  }

  renderCheckBoxes() {
    if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
      var exercises = (
        <span>
          <label>
            <span>Exercises</span>
            <input
              name='exercises'
              type="checkbox"
              checked={this.state.exercises}
              onChange={this.handleInputChange} />
          </label>
          {this.renderQuantity(EXERCISE_QUANTITY, EXERCISES)}
          <br />
        </span>
      )
    }

    return (
      <div className={'taskItemModal'}>
        <label>
          <span>Quiz</span>
          <input
            name='quiz'
            type="checkbox"
            checked={this.state.quiz}
            onChange={this.handleInputChange} />
        </label>
        <br />
        <label>
          <span>Practice Questions</span>
          <input
            name='practice_questions'
            type="checkbox"
            checked={this.state.practice_questions}
            onChange={this.handleInputChange} />
        </label>
        { this.renderQuantity(PRACTICE_QUESTION_QUANTITY, PRACTICE_QUESTIONS) }
        <br />
        { exercises }
        <label>
          <span>Question Builders</span>
          <input
            name='question_builders'
            type="checkbox"
            checked={this.state.question_builders}
            onChange={this.handleInputChange} />
        </label>
        { this.renderQuantity(QUESTION_BUILDER_QUANTITY, QUESTION_BUILDERS) }
        <br />
        <label>
          <span>Review</span>
          <input
            name='review'
            type="checkbox"
            checked={this.state.review}
            onChange={this.handleInputChange} />
        </label>
        <br />
        <label>
          <span>Add Due Date</span>
          <input
            name='due_date_enabled'
            type="checkbox"
            checked={this.state.due_date_enabled}
            onChange={this.handleInputChange} />
          </label>
        <br />
        { this.renderDatePicker() }
        <label>
          <span>None</span>
          <input
            name='none'
            type="checkbox"
            checked={this.state.none}
            onChange={this.handleNoneInput} />
        </label>

      </div>
    );
  }


  render() {
    return (
      <form>
        {this.renderCheckBoxes()}
        <LoadingButton className="btn buttonSuccess center-block"
          loading={this.state.loading} text={'Assign'}
          onClick={this.submitTasks} />
      </form>
    );
  }
};

var PRACTICE_QUESTIONS = 'practice_questions'
var PRACTICE_QUESTION_QUANTITY = 'practice_questions_quantity'
var EXERCISES = 'exercises'
var EXERCISE_QUANTITY = 'exercise_quantity'
var QUESTION_BUILDERS = 'question_builders'
var QUESTION_BUILDER_QUANTITY = 'question_builder_quantity'

var BASE_STATE = {
  none: false,
  quiz: false,
  review: false,
  practice_questions: false,
  practice_questions_quantity: 0,
  exercises: false,
  exercise_quantity: 0,
  question_builders: false,
  question_builder_quantity: 0,
  due_date_enabled: false
}

AssignTaskItemsModal.WrappedComponent.propTypes = StrictPropTypes({
  // ID of the task we're assigning
  taskSubjectID: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,

  onAssign: PropTypes.func,
  selectedUserIDs: PropTypes.array,

  // subject type of the task we are assigning
  taskSubjectType: PropTypes.string.isRequired,

  // From @connect
  tasks: PropTypes.array,
  selectedActivityTitle: PropTypes.string,
  createTaskItems: PropTypes.func,
  createTaskAssignment: PropTypes.func
});

module.exports = AssignTaskItemsModal;


// WEBPACK FOOTER //
// ./modules/components/writing/tasks/AssignTaskItemsModal.js